import geolib from 'geolib';
import { DEFAULT_DISTANCE_UNIT } from './localization/types';

export function convertMetersToMiles(distance) {
  return parseFloat(geolib.convertUnit(DEFAULT_DISTANCE_UNIT, distance));
}
